<template>
    <div class="search-filter">
        <div class="container full-width top">
            <div class="row">
                <!-- <div class="column" v-if='pageType==="pages.EventIndexPage"'>
                    <label for="start-date-filter" style="color: white;">Start Date
                    <input class="dropdown-button" type="date" name="start-date-filter" v-model="dateFilter.startDateFilter" @change='emitDateChange(dateFilter)'>
                    </label>
                </div>
                <div class="column" v-if='pageType==="pages.EventIndexPage"'>
                    <label for="end-date-filter" style="color: white;">End Date
                    <input type="date" name="end-date-filter" v-if='pageType==="pages.EventIndexPage"' v-model="dateFilter.endDateFilter" @change='emitDateChange(dateFilter)'>
                    </label>
                </div> -->
            
                <div class="column" style="color: white; text-align: center; position: relative;" v-for="(item, index) in searchItems" v-bind:key="item.title">
                    <button class="dropdown-button" type="button" style="border: thin solid white;" v-bind:class="{'selected': openTracker[index]}" @click="resetChoices(index)">{{ item.value.title }}</button>
                </div>
                <div class="column" style="text-align: center;">
                    <button class="btn" type="button" style="border: thin solid white;" @click="resetFilters">Reset</button>
                </div>
            </div>
        </div>

        <div class="container full-width bottom">
             <div class="row test">
                <div class="column" v-for="(item, index) in searchItems" v-bind:key="item.title"> 
                    <div class="dropdown-options row" v-bind:class="{ 'dropdown-open' : openTracker[index], 'double-row':item.value.search_options.length > 10 }">
                        <div class="menu-row column" v-for="row in splitMenu(item.value.search_options)" v-bind:key="row.parent_node">
                            <div v-for="so in row">
                                <label v-bind:for="'search_option_for_'+sOptionId(so.name, so.id)"><input type="checkbox" v-bind:id="'search_option_for_'+sOptionId(so.name, so.id)" name="node-filter" v-bind:value="so.id"  v-bind:title="so.name" v-model="filter_arrays[index]" @change='emitChange(filter_arrays)'>
                                {{ so.name }}</label>
                            </div>
                        </div>
                         <button class="done-button" @click="$set(openTracker, index, !openTracker[index]);">Done</button>
                    </div>
                      
                </div>
                <div class="column"></div>
            </div>
        </div> 
    </div>
   
</template>

<script>
import axios from 'axios'
export default{
    name: 'trailsearchblock',
    data() {
        return {
            filter_by: [],
            itemsPerRow: 12,
            dateFilter: {
                startDateFilter: null,
                endDateFilter: null,
            },
            filter_arrays: this.setFilterArray(),
            openTracker: this.searchItems.map(item => false),
        }
    },
    props: {
        searchItems: {
            type: Array,
            required: true,
        },
        pageType: {
            type: String,
            required: false,
        }
    },
    watch:{
        $route (to, from){
            this.openTracker = this.searchItems.map(item => false)
        }
    },
    computed: {
        numRows() {
            return Math.ceil
        }
    },
    mounted (){
        
    },
    created (){
        window.addEventListener('click', this.documentClick)
    },
    destroyed (){
        window.removeEventListener('click', this.documentClick)
    },
    methods: {
        documentClick(e){
            var checkboxes = document.getElementsByClassName('dropdown-options')
            var buttons = document.getElementsByClassName('dropdown-button')
            var el_array = Array.prototype.slice.call(buttons)
            var show_it = el_array.indexOf(e.target)
            var contains = false

            // if (buttons.indexOf(e.target))
            console.log(typeof(this.openTracker))
            console.log('search items: ', this.openTracker.indexOf(true))
            if(e.target.classList.contains('dropdown-button') && this.openTracker.indexOf(true) !== -1 ){
                // this.openTracker = this.searchItems.map(item => false)
                console.log('OPEN TRACKER')
            }

            for(var index = 0; index < checkboxes.length; index++){
                console.log('JOSH: ', checkboxes[index].contains(e.target))
                if(checkboxes[index].contains(e.target)){
                   contains = true
                }
            }

            if (show_it === -1 && contains !== true) {
               this.openTracker = this.searchItems.map(item => false)
            }
        },
        emitChange(filter) {
            console.log('FILTER: ',filter)

            this.$emit('filterChange', filter)
        },
        emitDateChange(filter) {
            this.$emit('dateFilterChange', filter)
        },
        setFilterArray: function() {
            var data = []
            for (var item in this.searchItems) {
                data.push([])
            }
            return data
        },
        resetFilters() {
            this.filter_arrays = this.setFilterArray();
            this.emitChange(this.filter_arrays);
        },
        sOptionId(name, id) {
            return name.toLowerCase().split(' ').join('') + '-' + id
        },
        resetChoices(i) {
            let choice = this.openTracker[i]
            if (choice){
                this.openTracker = this.openTracker.map( item => false)
            }else{
                this.openTracker = this.openTracker.map( item => false)
                this.openTracker[i] = true
            }
        },
        splitMenu(menu){
            var full = menu.slice(0)
            var chunk = []
            // console.log('MENU: ', menu)
            // if( menu.length > 12){
            //     console.log('CHUNK')
            while(full.length){
                chunk.push(full.splice(0, 7))
            }
            //  console.log('CHUNK: ', chunk)
            return chunk
            // }else{
            //     return menu
            // }
           
        }
    }
}
</script>

<style lang="sass">
    button
        transition: background .25s ease-in-out;
    button.selected
        // background: $color-pink
        // background: #ef6537
        // background: #efef37
        // color: $color-primary
        // ::hover
        //     background: $color-tertiary
    button.selected:hover
        // background: $color-pink
        // background: #ef6537
        // background: #efef37
        
</style>

<style scoped>
    .dropdown-options {
        background-color: #585858;
        color: #ffffff;
        /* overflow: scroll; */
        padding: 2rem;
        transition: all .25s ease-in-out;
        top: 0px;
        left: 9px;
        transform: translateY(-100%);
        z-index: 1;
        position: absolute;
        width: 100%;
        text-align: left;
        padding: 2rem 2rem 7rem 2rem !important;
    }

    .search-filter > .full-width > .row{
        max-width: 112rem;
        padding: 0;
        margin: 0 auto;
    }

    .search-filter .done-button{
        position: absolute;
        bottom: 2rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 80%;
    }

    .dropdown-open {
        /* max-height: 500px; */
        /* border: white thin solid; */
        transform: translateY(0);
        z-index: 1;
    }

    .double-row{
        width: 55rem;
    }

    .search-filter{
        /* padding: 1.5rem 0; */
    }

    .search-filter button{
        width: 80%;
        text-align: center;
    }

    .search-filter .top{
        background: #333;
        position: relative;
        z-index: 2;
    }

    .search-filter button{
        width: 100%;
    }

    .search-filter .top /* .search-filter .bottom */{
        padding: 2rem 1rem;
    }

    .search-filter button{
        margin: 0;
    }
</style>